// Global Instructions Rule Applied!

/**
 * Centralized file-related constants used across the application
 * These constants provide a single source of truth for file upload and management values
 */

// ========================
// File Upload Types
// ========================
export const FILE_TYPE = 'file'
export const URL_TYPE = 'url'

// ========================
// Office File Viewer
// ========================
export const OFFICE_VIEWER_URL = 'https://view.officeapps.live.com/op/view.aspx?src='
export const OFFICE_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'odt', 'ods', 'odp']

// ========================
// Date Formatting
// ========================
export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'
